import React from 'react'
import { Tooltip } from 'antd'
import { CustomText } from 'src/components'
import { Offer, UserSaleOffer } from 'src/core/models'
import { getFirstSubstring } from 'src/core/helpers'

const SaleOfferProjectColumn: React.FC<{ offer: UserSaleOffer | Offer }> = ({ offer }) => {
  const span = <CustomText label={offer.project_name} />

  return <>
    {offer.project_name.length >= 18 ? (
      <Tooltip
        title={offer.project_name}
        color='cyan'
      >
        {`${getFirstSubstring(offer.project_name, 18)}...`}
      </Tooltip>
    ): <>{span}</>} <br/>
    {offer.vintage_year && (
      <CustomText
        label={offer.vintage_year}
        type='secondary'
      />
    )}
  </>
}

export default SaleOfferProjectColumn
